// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TOS_POPUP-action {
  color: var(--tos-link-color);
}
.TOS_POPUP-text {
  color: var(--tos-text-color);
}`, "",{"version":3,"sources":["webpack://./src/components/ui/SanitizeHtml/SanitizeHtml.scss"],"names":[],"mappings":"AACI;EACI,4BAAA;AAAR;AAGI;EACI,4BAAA;AADR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
